"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import Script from "next/script";
import { configureAutoDrivenFrame, prepareAutoDrivenInsertion } from "./autoDrivenFramePolicy";

/** Register the iframe policy before the vendor can inject its cross-origin frame. */
export default function AutoDrivenLoader(t0) {
  const $ = _c(5);
  const {
    pageType
  } = t0;
  const [ready, setReady] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const restoreInsertion = prepareAutoDrivenInsertion(document.body);
      const configure = _temp2;
      const observer = new MutationObserver(configure);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      configure();
      setReady(true);
      return () => {
        observer.disconnect();
        restoreInsertion();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== pageType || $[3] !== ready) {
    t3 = ready ? <Script src="https://digital-retail.autodriven.com/loader.js" data-page-type={pageType} {...pageType === "SRP" ? {
      "data-inventory-type": "USED"
    } : {}} strategy="afterInteractive" /> : null;
    $[2] = pageType;
    $[3] = ready;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2() {
  return document.querySelectorAll("iframe#capital-one-prequalification-orchestrator").forEach(_temp);
}
function _temp(frame) {
  return configureAutoDrivenFrame(frame);
}